import { createContext, useContext } from 'react';
import { editorialLayout } from './editorial';
import type { BlockStyleKey, LandingLayout } from './types';

export const LayoutContext = createContext<LandingLayout>(editorialLayout);

export const useLayout = (): LandingLayout => useContext(LayoutContext);

export const useLayoutStyles = <K extends BlockStyleKey>(block: K): LandingLayout[K] =>
  useContext(LayoutContext)[block];
